import React from 'react';

/**
 * Standardized header block for V2 pages.
 *
 * Renders the design-system `.page-head` pattern: a left side with an
 * optional uppercase eyebrow + h1 + sub-paragraph, and a right side
 * with action elements (passed in as `actions`).
 *
 *   <PageHead
 *     eyebrow="NUTRITION · TODAY"
 *     title="1,840 of 2,200 kcal"
 *     sub="360 kcal remaining today."
 *     actions={
 *       <>
 *         <button className="btn btn-secondary">Edit plan</button>
 *         <button className="btn btn-grad">Log food</button>
 *       </>
 *     }
 *   />
 *
 * Why a component instead of just leaving the markup inline: the same
 * eyebrow/h1/sub/actions structure repeats across HomeV2, StatsPageV2,
 * NutritionPageV2, AdminClientsPageV2, FoodCompliancePage. Centralizing
 * means future tweaks (e.g. mobile gutter, action wrap behavior) happen
 * in one place. We keep the existing `.page-head` CSS — this is a markup
 * helper, not a new design.
 *
 * Note: this is intentionally separate from the legacy `<TitleSection>`,
 * which is route-driven and global. PageHead is data-driven and lives
 * inside the page that owns its data.
 */
export default function PageHead({ eyebrow, title, sub, actions, className }) {
  const cls = `page-head${className ? ` ${className}` : ''}`;
  return (
    <div className={cls}>
      <div>
        {eyebrow ? <div className="hello">{eyebrow}</div> : null}
        {title ? <h1>{title}</h1> : null}
        {sub ? <p className="sub">{sub}</p> : null}
      </div>
      {actions ? (
        <div className="page-head-actions">{actions}</div>
      ) : null}
    </div>
  );
}
